import { useState, useEffect } from 'react';
import butterflyApi from '../ButterflyApi';
import JSONPretty from 'react-json-pretty';

const Summary = () => {
  const [summary, setSummary] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      const data = await butterflyApi.getSummary()
      setSummary(data)
      setLoading(false)
    }
    load()
  }, [])

  return <div className="px-4 mt-12 max-w-4xl">
    <div className="mb-4">
      <a href="/manage" className="text-blue-600 underline">Manage</a>
    </div>
    <div className="text-lg font-bold mb-4">Summary</div>
    {loading && <div className="text-gray-500 mb-4">로딩중...</div>}
    {summary && <div className="text-xs">
      <JSONPretty id="json-pretty" data={summary}></JSONPretty>
    </div>}
  </div>
}

export default Summary
